import { useState, RefObject } from 'react';

import { Box } from '../../../Box';
import { FilePreview } from '../../../FilePreview';
import { FileInputPreviewActions } from '../FileInputPreviewActions';
import useStyles from '../FileInput.styles';

interface FileInputPreviewDocumentProps {
  blobDocument: RefObject<Blob | null>;
  allowedTypes: string[];
  isDesktop: boolean;
  disabled?: boolean;
  testId: string;
  onLoad: () => Promise<Blob>;
  onRemove: () => void;
  onRotate: () => void;
}

export const FileInputPreviewDocument = ({
  blobDocument,
  allowedTypes,
  isDesktop,
  disabled,
  testId,
  onLoad,
  onRemove,
  onRotate,
}: FileInputPreviewDocumentProps) => {
  const { classes } = useStyles();
  const [isButtonsVisible, setIsButtonsVisible] = useState(false);

  const handleRemove = () => {
    onRemove();
    setIsButtonsVisible(false);
  };

  return (
    <div
      className={classes.filePreview}
      data-testid={`${testId}-preview`}
      onMouseEnter={() => setIsButtonsVisible(true)}
      onMouseLeave={() => setIsButtonsVisible(false)}
    >
      <FileInputPreviewActions
        isDesktop={isDesktop}
        blobDocument={blobDocument}
        allowedTypes={allowedTypes}
        isButtonsVisible={isButtonsVisible}
        disabled={disabled}
        testId={testId}
        onRemove={handleRemove}
        onRotate={onRotate}
      >
        <Box height="100%">
          <FilePreview withFlex onLoad={onLoad} withZoom />
        </Box>
      </FileInputPreviewActions>
    </div>
  );
};
